(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8495],{

/***/ 80476:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models",
      function () {
        return __webpack_require__(12830);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var common_SeoMetaData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25384);
/* harmony import */ var components_modelsPage_ModelsPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58280);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledPageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "models__StyledPageWrapper",
    componentId: "sc-ab33c88e-0"
})(_templateObject(), theme_shared__WEBPACK_IMPORTED_MODULE_4__/* .HEADER_HEIGHT_M */ .Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, theme_shared__WEBPACK_IMPORTED_MODULE_4__/* .HEADER_HEIGHT_D */ .gw);
var Models = function(param) {
    var seo = param.seo, modelsData = param.modelsData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_SeoMetaData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPageWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_modelsPage_ModelsPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    modelsData: modelsData.cars,
                    futureCarsOrderType: modelsData.futureCarsOrderType
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Models);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9794,9774,2888,179], function() { return __webpack_exec__(80476); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);